import React from 'react'
import { Flex, Span, Grid, styled, Link } from '@fareye/ui'
import {
  toTileCase,
  startCase,
  FaSignal,
  isEmpty,
  FaBatteryEmpty,
  FaBatteryFull,
  FaBatteryQuarter,
  FaBatteryThreeQuarters,
  capitalize
} from '@fareye/utils'
import { tripTabsBackground } from '@fareye/configs'
import { displayTime } from '../../../utility/function'
import CEmission from '../../../components/CEmission'
import { useTranslation } from '@fareye/common'
import { DeviceDetails } from '@fareye/intransit'

const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripTabsBackground,
    padding: '12px'
  }
}
const Fa: any = {
  FaBatteryEmpty,
  FaBatteryFull,
  FaBatteryQuarter,
  FaBatteryThreeQuarters
}

export const EndCirle = styled.div`
  box-sizing: border-box;
  height: 6px;
  width: 6px;
  opacity: 0.9;
  margin-top: 4px;
  border-radius: 50%;
  background-color: #727272;
`

export const StartCirle = styled.div`
  box-sizing: border-box;
  height: 7px;
  width: 7px;
  margin-top: 4px;
  border: 1px solid #727272;
  opacity: 0.9;
  border-radius: 50%;
`

export const StoryTimeLine = styled.div`
  box-sizing: border-box;
  height: 20px;
  width: 1px;
  border-radius: 50%;
  border: 1px dashed #979797;
  margin-left: 2px;
  margin-top: -7px;
  margin-bottom: -3px;
`
export const ValueSpan = styled(Span)`
  font-size: 14px;
  font-weight-500;
`

export const StoryLine = ({ dataSet }: any) => (
  <Flex column>
    {dataSet.map((item: string, index: number) => {
      return (
        <Flex column key={`${item}${index}`}>
          <Flex>
            {index === dataSet.length - 1 ? <EndCirle /> : <StartCirle />}
            <Span ml={13} variant={'secondary'} style={{ fontSize: '14px' }}>
              {item}
            </Span>
          </Flex>
          {index !== dataSet.length - 1 && <StoryTimeLine />}
        </Flex>
      )
    })}
  </Flex>
)

const Heading = styled(Span)`
  font-size: 14px;
  margin-top: 6px;
  color: ${(props: any) => props.theme.colors[props?.title || 'inherit']};
`
const stringtoReactIconName = (name: string) =>
  name
    .split('-')
    .map(item => capitalize(item))
    .join('')

export const Summary = ({ data, type, config, changeTab, otherData }: any) => {
  const { exceptions = [] } = otherData
  let {
    shipmentNo,
    inState,
    status,
    itemQty,
    actStartTime,
    actEndTime,
    expStartTime,
    expEndTime,
    packageLegs = [],
    startLocation,
    endLocation,
    latestJourney,
    handlingUnitPackageType,
    delayCount = 0,
    billOfLading,
    percTripCovered = ''
  } = data
  itemQty = itemQty || otherData?.items?.length
  const {
    config: { links, currentTransporterColumns, showHideFeatures }
  } = config
  const { showco2 } = showHideFeatures || {}
  const co2 = packageLegs.reduce((a: any, b: any) => {
    a += b?.sustainabilityData?.co2Emission || 0
    return a
  }, 0)
  const columns =
    currentTransporterColumns[
      latestJourney.transportMode === null
        ? 'road'
        : latestJourney.transportMode
    ]
  const shipmentId: any = packageLegs.find(
    (item: any) => item.vehicleNo === latestJourney?.vehicleNo
  )
  const Icon =
    !isEmpty(latestJourney?.deviceInfo) &&
    Fa[stringtoReactIconName(latestJourney.deviceInfo.batteryStrength.icon)]

  const { t } = useTranslation()

  return (
    <Flex style={style.tripTabs} column>
      <Flex justifyContentSpaceBetween>
        <Span style={{ fontSize: '14px', fontWeight: 600 }}>
          {t('Package Details')}
        </Span>
        {/* <Span style={{ fontSize: '12px' }}>
          Trip Completion
          <Span
            variant={'primary'}
            style={{ fontSize: '14px', marginLeft: '4px' }}
          >
            {`${
              percTripCovered && percTripCovered !== null
                ? `${percTripCovered}%`
                : '-'
            }`}
          </Span>
        </Span> */}
        <Flex
          bg="#FBEFC3"
          style={{
            alignItems: 'center',
            padding: '1px 3px',
            display: showco2 ? 'flex' : 'none'
          }}
        >
          <CEmission />
          <Flex style={{ marginLeft: '5px' }}>
            <Span color="#727272">Co2 : </Span>
            <Span style={{ fontWeight: 500 }}>
              {co2 ? ` ${co2} mt` : ' - '}
            </Span>
          </Flex>
        </Flex>
      </Flex>
      <Grid
        gridTemplateColumns={'1fr 1fr 1fr'}
        style={{
          width: '96%',
          margin: '12px 0px 4px '
        }}
      >
        <Flex column>
          <Span variant={'secondary'} style={{ fontSize: '14px' }}>
            {t('Trip State')}
          </Span>
          <Heading title={inState}>
            {inState ? t(startCase(inState)) : '-'}
          </Heading>
        </Flex>
        <Flex column>
          <Span variant={'secondary'} style={{ fontSize: '14px' }}>
            {t('Status')}
          </Span>
          <Heading title={status}>
            {status ? t(startCase(status.replace('_', ' '))) : '-'}
          </Heading>
        </Flex>
        <Flex column>
          <Span variant={'secondary'} style={{ fontSize: '14px' }}>
            {t('Exceptions')}
          </Span>
          <Heading>{exceptions.length}</Heading>
        </Flex>
        {/* <Flex column>
          <Span variant={'secondary'} style={{ fontSize: '14px' }}>
            Delays
          </Span>
          <Heading>{delayCount}</Heading>
        </Flex> */}
      </Grid>
      <hr
        style={{
          boxSizing: 'border-box',
          height: '1px',
          width: '100%',
          border: '1px solid #DADADA'
        }}
      />
      <Grid gridTemplateColumns={'1fr 1fr'} style={{ margin: '4px 0px 4px' }}>
        <Span variant={'secondary'} style={{ fontSize: '14px' }}>
          {t('Package Id')}
        </Span>
        <ValueSpan>{shipmentNo || '-'}</ValueSpan>
      </Grid>
      <Grid gridTemplateColumns={'1fr 1fr'} style={{ margin: '4px 0px 4px' }}>
        <StoryLine dataSet={[t('Origin'), t('Destination')]} />
        <Flex column>
          <ValueSpan>{startLocation.locationName}</ValueSpan>
          <ValueSpan style={{ marginTop: '6px' }}>
            {endLocation.locationName}
          </ValueSpan>
        </Flex>
      </Grid>

      <Grid gridTemplateColumns={'1fr 1fr'} style={{ margin: '4px 0px 4px' }}>
        <Span variant={'secondary'} style={{ fontSize: '14px' }}>
          {t('Package Type')}
        </Span>
        <ValueSpan>{handlingUnitPackageType || '-'}</ValueSpan>
      </Grid>

      <Grid gridTemplateColumns={'1fr 1fr'} style={{ margin: '4px 0px 4px' }}>
        <Span variant={'secondary'} style={{ fontSize: '14px' }}>
          {t('Number of Items')}
        </Span>
        <ValueSpan
          variant={'primary'}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            changeTab('itemDetails')
          }}
        >
          {itemQty || '-'}
        </ValueSpan>
      </Grid>

      <Grid gridTemplateColumns={'1fr 1fr'} style={{ margin: '4px 0px 4px' }}>
        <Span variant={'secondary'} style={{ fontSize: '14px' }}>
          {t('Total Stops/Legs')}
        </Span>
        <ValueSpan>{packageLegs.length > 0 ? packageLegs.length : 0}</ValueSpan>
      </Grid>
      <Grid gridTemplateColumns={'1fr 1fr'} style={{ margin: '4px 0px 4px' }}>
        <Span
          variant={'secondary'}
          style={{ fontSize: '14px' }}
          title={'Start time from where tracking of the trip is shown'}
        >
          {t('Trip start time')}
        </Span>
        <ValueSpan>
          {actStartTime?.time !== null
            ? displayTime(actStartTime)
            : expStartTime?.time
            ? displayTime(expStartTime)
            : '-'}
        </ValueSpan>
      </Grid>
      <Grid gridTemplateColumns={'1fr 1fr'} style={{ margin: '4px 0px 4px' }}>
        <Span
          variant={'secondary'}
          style={{ fontSize: '14px' }}
          title={'Last time till which tracking of the trip is shown'}
        >
          {t('Trip Closure time')}
        </Span>
        <ValueSpan>
          {actEndTime?.time !== null ? displayTime(actEndTime) : '-'}
        </ValueSpan>
      </Grid>
      <Flex
        justifyContentSpaceBetween
        style={{ width: '96%', margin: '12px 0px 12px' }}
      >
        <Span style={{ fontSize: '14px', fontWeight: 600 }}>
          {t('Current Transporter Details')}
        </Span>
        <DeviceDetails deviceInfo={latestJourney?.deviceInfo} t={t} />
      </Flex>
      {columns.map((item: any, i: number) => {
        const { key, label, main = false } = item
        switch (item.key) {
          case 'route':
            return (
              <Grid
                gridTemplateColumns={'1fr 1fr'}
                style={{ margin: '4px 0px 4px' }}
                key={i}
              >
                <Span variant={'secondary'} style={{ fontSize: '14px' }}>
                  {t(label)}
                </Span>
                <ValueSpan>
                  {latestJourney &&
                    `${latestJourney.loadingPoint} - ${latestJourney.unloadingPoint}`}
                </ValueSpan>
              </Grid>
            )
          case 'transshipment':
            return (
              <Grid
                gridTemplateColumns={'1fr 1fr'}
                style={{ margin: '4px 0px 4px' }}
                key={i}
              >
                <Span variant={'secondary'} style={{ fontSize: '14px' }}>
                  {t(label)}
                </Span>
                <ValueSpan>
                  {!isEmpty(data.transshipment)
                    ? data.transshipment.join(' , ')
                    : t('Direct')}
                </ValueSpan>
              </Grid>
            )
          case 'shipmentId':
            return (
              <Grid
                gridTemplateColumns={'1fr 1fr'}
                style={{ margin: '4px 0px 4px' }}
                key={i}
              >
                <Span variant={'secondary'} style={{ fontSize: '14px' }}>
                  {t(label)}
                </Span>
                <Link
                  target="_blank"
                  variant="xs"
                  to={`${links.shipmentShare}/${shipmentId && shipmentId.slug}`}
                >
                  {shipmentId ? shipmentId.lrNo : '-'}
                </Link>
              </Grid>
            )
          case 'billOfLading':
            return (
              <Grid
                gridTemplateColumns={'1fr 1fr'}
                style={{ margin: '4px 0px 4px' }}
                key={i}
              >
                <Span variant={'secondary'} style={{ fontSize: '14px' }}>
                  {t(label)}
                </Span>
                <ValueSpan>{billOfLading ? billOfLading : '-'}</ValueSpan>
              </Grid>
            )
          case 'vehicleNo':
            return (
              <Grid
                gridTemplateColumns={'1fr 1fr'}
                style={{ margin: '4px 0px 4px' }}
                key={i}
              >
                <Span variant={'secondary'} style={{ fontSize: '14px' }}>
                  {t(label)}
                </Span>
                <ValueSpan>
                  {data?.latestJourney['vehicleNo']
                    ? data?.latestJourney['vehicleNo'].toUpperCase()
                    : '-'}
                </ValueSpan>
              </Grid>
            )
          default:
            let val = main ? data[key] : data?.latestJourney[key]
            return (
              <Grid
                gridTemplateColumns={'1fr 1fr'}
                style={{ margin: '4px 0px 4px' }}
                key={i}
              >
                <Span variant={'secondary'} style={{ fontSize: '14px' }}>
                  {t(label)}
                </Span>
                <ValueSpan>{val}</ValueSpan>
              </Grid>
            )
        }
      })}
    </Flex>
  )
}
